import Switch, { SwitchProps } from './Switch';

export type { SwitchProps };
export default Switch;
